import { getHashSiteId } from './storage';
import { userFacingError } from './errors';

const API_BASE = () => (import.meta.env.VITE_BACKEND_URL || '').replace(/\/$/, '');

export function apiUrl(path, params = {}) {
  const url = new URL(`${API_BASE()}${path.startsWith('/') ? path : `/${path}`}`);
  const id = params.id || getHashSiteId();
  if (id) url.searchParams.set('id', id);
  for (const [key, value] of Object.entries(params)) {
    if (key === 'id') continue;
    if (value != null && value !== '') url.searchParams.set(key, String(value));
  }
  return url.toString();
}

export async function apiFetch(path, options = {}, params = {}) {
  let response;
  const method = String(options.method || 'GET').toUpperCase();
  const hasBody = options.body != null && options.body !== '';
  const headers = {
    Accept: 'application/json',
    ...(options.headers || {}),
  };
  // Avoid Content-Type: application/json on body-less DELETE/GET — Fastify rejects empty JSON bodies.
  if (hasBody || (method !== 'GET' && method !== 'HEAD' && method !== 'DELETE')) {
    if (!headers['Content-Type'] && !headers['content-type']) {
      headers['Content-Type'] = 'application/json';
    }
  }

  try {
    response = await fetch(apiUrl(path, params), {
      ...options,
      headers,
    });
  } catch (networkErr) {
    const err = new Error(userFacingError(networkErr, 'Network error. Check your connection and try again.'));
    err.status = 0;
    err.cause = networkErr;
    throw err;
  }

  const text = await response.text();
  let data = null;
  if (text) {
    try {
      data = JSON.parse(text);
    } catch {
      data = null;
    }
  }

  if (!response.ok) {
    const err = new Error(
      userFacingError(
        { status: response.status, data, message: data?.error || data?.message },
        'Something went wrong. Please try again.',
      ),
    );
    err.status = response.status;
    err.data = data;
    err.code = data?.code;
    throw err;
  }

  return data;
}
